// extracted by mini-css-extract-plugin
module.exports = {"questionItemList":"QuestionItemList_questionItemList__268_R","questionItem":"QuestionItemList_questionItem__Txftv"};